/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DiretoriaRouteImport } from './routes/diretoria'
import { Route as GestaoRouteRouteImport } from './routes/gestao/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MinhaSenhaRouteImport } from './routes/minha-senha'
import { Route as PainelRouteImport } from './routes/painel'
import { Route as GestaoIndexRouteImport } from './routes/gestao/index'
import { Route as GestaoAtividadesRouteImport } from './routes/gestao/atividades'
import { Route as GestaoAusenciasRouteImport } from './routes/gestao/ausencias'
import { Route as GestaoAvaliacaoRouteImport } from './routes/gestao/avaliacao'
import { Route as GestaoBonusRouteImport } from './routes/gestao/bonus'
import { Route as GestaoConfiguracoesRouteImport } from './routes/gestao/configuracoes'
import { Route as GestaoFabricaRouteImport } from './routes/gestao/fabrica'
import { Route as GestaoIndicadoresRouteImport } from './routes/gestao/indicadores'
import { Route as GestaoMotivosPausaRouteImport } from './routes/gestao/motivos-pausa'
import { Route as GestaoMotivosPerdaRouteImport } from './routes/gestao/motivos-perda'
import { Route as GestaoOrigensRouteImport } from './routes/gestao/origens'
import { Route as GestaoProdutosRouteImport } from './routes/gestao/produtos'
import { Route as GestaoTurnosRouteImport } from './routes/gestao/turnos'
import { Route as GestaoUsuariosRouteImport } from './routes/gestao/usuarios'
import { Route as PostoIndexRouteImport } from './routes/posto/index'
import { Route as PostoPostoIdRouteImport } from './routes/posto/$postoId'
import { Route as GestaoFechamentosIndexRouteImport } from './routes/gestao/fechamentos/index'
import { Route as GestaoFechamentosFechamentoIdRouteImport } from './routes/gestao/fechamentos/$fechamentoId'
import { Route as GestaoPedidosIndexRouteImport } from './routes/gestao/pedidos/index'
import { Route as GestaoPedidosPedidoIdRouteImport } from './routes/gestao/pedidos/$pedidoId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DiretoriaRoute = DiretoriaRouteImport.update({
  id: '/diretoria',
  path: '/diretoria',
  getParentRoute: () => rootRouteImport,
} as any)
const GestaoRouteRoute = GestaoRouteRouteImport.update({
  id: '/gestao',
  path: '/gestao',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MinhaSenhaRoute = MinhaSenhaRouteImport.update({
  id: '/minha-senha',
  path: '/minha-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const PainelRoute = PainelRouteImport.update({
  id: '/painel',
  path: '/painel',
  getParentRoute: () => rootRouteImport,
} as any)
const GestaoIndexRoute = GestaoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoAtividadesRoute = GestaoAtividadesRouteImport.update({
  id: '/atividades',
  path: '/atividades',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoAusenciasRoute = GestaoAusenciasRouteImport.update({
  id: '/ausencias',
  path: '/ausencias',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoAvaliacaoRoute = GestaoAvaliacaoRouteImport.update({
  id: '/avaliacao',
  path: '/avaliacao',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoBonusRoute = GestaoBonusRouteImport.update({
  id: '/bonus',
  path: '/bonus',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoConfiguracoesRoute = GestaoConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoFabricaRoute = GestaoFabricaRouteImport.update({
  id: '/fabrica',
  path: '/fabrica',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoIndicadoresRoute = GestaoIndicadoresRouteImport.update({
  id: '/indicadores',
  path: '/indicadores',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoMotivosPausaRoute = GestaoMotivosPausaRouteImport.update({
  id: '/motivos-pausa',
  path: '/motivos-pausa',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoMotivosPerdaRoute = GestaoMotivosPerdaRouteImport.update({
  id: '/motivos-perda',
  path: '/motivos-perda',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoOrigensRoute = GestaoOrigensRouteImport.update({
  id: '/origens',
  path: '/origens',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoProdutosRoute = GestaoProdutosRouteImport.update({
  id: '/produtos',
  path: '/produtos',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoTurnosRoute = GestaoTurnosRouteImport.update({
  id: '/turnos',
  path: '/turnos',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoUsuariosRoute = GestaoUsuariosRouteImport.update({
  id: '/usuarios',
  path: '/usuarios',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const PostoIndexRoute = PostoIndexRouteImport.update({
  id: '/posto/',
  path: '/posto/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostoPostoIdRoute = PostoPostoIdRouteImport.update({
  id: '/posto/$postoId',
  path: '/posto/$postoId',
  getParentRoute: () => rootRouteImport,
} as any)
const GestaoFechamentosIndexRoute = GestaoFechamentosIndexRouteImport.update({
  id: '/fechamentos/',
  path: '/fechamentos/',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoFechamentosFechamentoIdRoute =
  GestaoFechamentosFechamentoIdRouteImport.update({
    id: '/fechamentos/$fechamentoId',
    path: '/fechamentos/$fechamentoId',
    getParentRoute: () => GestaoRouteRoute,
  } as any)
const GestaoPedidosIndexRoute = GestaoPedidosIndexRouteImport.update({
  id: '/pedidos/',
  path: '/pedidos/',
  getParentRoute: () => GestaoRouteRoute,
} as any)
const GestaoPedidosPedidoIdRoute = GestaoPedidosPedidoIdRouteImport.update({
  id: '/pedidos/$pedidoId',
  path: '/pedidos/$pedidoId',
  getParentRoute: () => GestaoRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/gestao': typeof GestaoRouteRouteWithChildren
  '/diretoria': typeof DiretoriaRoute
  '/login': typeof LoginRoute
  '/minha-senha': typeof MinhaSenhaRoute
  '/painel': typeof PainelRoute
  '/gestao/atividades': typeof GestaoAtividadesRoute
  '/gestao/ausencias': typeof GestaoAusenciasRoute
  '/gestao/avaliacao': typeof GestaoAvaliacaoRoute
  '/gestao/bonus': typeof GestaoBonusRoute
  '/gestao/configuracoes': typeof GestaoConfiguracoesRoute
  '/gestao/fabrica': typeof GestaoFabricaRoute
  '/gestao/indicadores': typeof GestaoIndicadoresRoute
  '/gestao/motivos-pausa': typeof GestaoMotivosPausaRoute
  '/gestao/motivos-perda': typeof GestaoMotivosPerdaRoute
  '/gestao/origens': typeof GestaoOrigensRoute
  '/gestao/produtos': typeof GestaoProdutosRoute
  '/gestao/turnos': typeof GestaoTurnosRoute
  '/gestao/usuarios': typeof GestaoUsuariosRoute
  '/posto/$postoId': typeof PostoPostoIdRoute
  '/gestao/': typeof GestaoIndexRoute
  '/posto/': typeof PostoIndexRoute
  '/gestao/fechamentos/$fechamentoId': typeof GestaoFechamentosFechamentoIdRoute
  '/gestao/pedidos/$pedidoId': typeof GestaoPedidosPedidoIdRoute
  '/gestao/fechamentos/': typeof GestaoFechamentosIndexRoute
  '/gestao/pedidos/': typeof GestaoPedidosIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/diretoria': typeof DiretoriaRoute
  '/login': typeof LoginRoute
  '/minha-senha': typeof MinhaSenhaRoute
  '/painel': typeof PainelRoute
  '/gestao/atividades': typeof GestaoAtividadesRoute
  '/gestao/ausencias': typeof GestaoAusenciasRoute
  '/gestao/avaliacao': typeof GestaoAvaliacaoRoute
  '/gestao/bonus': typeof GestaoBonusRoute
  '/gestao/configuracoes': typeof GestaoConfiguracoesRoute
  '/gestao/fabrica': typeof GestaoFabricaRoute
  '/gestao/indicadores': typeof GestaoIndicadoresRoute
  '/gestao/motivos-pausa': typeof GestaoMotivosPausaRoute
  '/gestao/motivos-perda': typeof GestaoMotivosPerdaRoute
  '/gestao/origens': typeof GestaoOrigensRoute
  '/gestao/produtos': typeof GestaoProdutosRoute
  '/gestao/turnos': typeof GestaoTurnosRoute
  '/gestao/usuarios': typeof GestaoUsuariosRoute
  '/posto/$postoId': typeof PostoPostoIdRoute
  '/gestao': typeof GestaoIndexRoute
  '/posto': typeof PostoIndexRoute
  '/gestao/fechamentos/$fechamentoId': typeof GestaoFechamentosFechamentoIdRoute
  '/gestao/pedidos/$pedidoId': typeof GestaoPedidosPedidoIdRoute
  '/gestao/fechamentos': typeof GestaoFechamentosIndexRoute
  '/gestao/pedidos': typeof GestaoPedidosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/gestao': typeof GestaoRouteRouteWithChildren
  '/diretoria': typeof DiretoriaRoute
  '/login': typeof LoginRoute
  '/minha-senha': typeof MinhaSenhaRoute
  '/painel': typeof PainelRoute
  '/gestao/atividades': typeof GestaoAtividadesRoute
  '/gestao/ausencias': typeof GestaoAusenciasRoute
  '/gestao/avaliacao': typeof GestaoAvaliacaoRoute
  '/gestao/bonus': typeof GestaoBonusRoute
  '/gestao/configuracoes': typeof GestaoConfiguracoesRoute
  '/gestao/fabrica': typeof GestaoFabricaRoute
  '/gestao/indicadores': typeof GestaoIndicadoresRoute
  '/gestao/motivos-pausa': typeof GestaoMotivosPausaRoute
  '/gestao/motivos-perda': typeof GestaoMotivosPerdaRoute
  '/gestao/origens': typeof GestaoOrigensRoute
  '/gestao/produtos': typeof GestaoProdutosRoute
  '/gestao/turnos': typeof GestaoTurnosRoute
  '/gestao/usuarios': typeof GestaoUsuariosRoute
  '/posto/$postoId': typeof PostoPostoIdRoute
  '/gestao/': typeof GestaoIndexRoute
  '/posto/': typeof PostoIndexRoute
  '/gestao/fechamentos/$fechamentoId': typeof GestaoFechamentosFechamentoIdRoute
  '/gestao/pedidos/$pedidoId': typeof GestaoPedidosPedidoIdRoute
  '/gestao/fechamentos/': typeof GestaoFechamentosIndexRoute
  '/gestao/pedidos/': typeof GestaoPedidosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/gestao'
    | '/diretoria'
    | '/login'
    | '/minha-senha'
    | '/painel'
    | '/gestao/atividades'
    | '/gestao/ausencias'
    | '/gestao/avaliacao'
    | '/gestao/bonus'
    | '/gestao/configuracoes'
    | '/gestao/fabrica'
    | '/gestao/indicadores'
    | '/gestao/motivos-pausa'
    | '/gestao/motivos-perda'
    | '/gestao/origens'
    | '/gestao/produtos'
    | '/gestao/turnos'
    | '/gestao/usuarios'
    | '/posto/$postoId'
    | '/gestao/'
    | '/posto/'
    | '/gestao/fechamentos/$fechamentoId'
    | '/gestao/pedidos/$pedidoId'
    | '/gestao/fechamentos/'
    | '/gestao/pedidos/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/diretoria'
    | '/login'
    | '/minha-senha'
    | '/painel'
    | '/gestao/atividades'
    | '/gestao/ausencias'
    | '/gestao/avaliacao'
    | '/gestao/bonus'
    | '/gestao/configuracoes'
    | '/gestao/fabrica'
    | '/gestao/indicadores'
    | '/gestao/motivos-pausa'
    | '/gestao/motivos-perda'
    | '/gestao/origens'
    | '/gestao/produtos'
    | '/gestao/turnos'
    | '/gestao/usuarios'
    | '/posto/$postoId'
    | '/gestao'
    | '/posto'
    | '/gestao/fechamentos/$fechamentoId'
    | '/gestao/pedidos/$pedidoId'
    | '/gestao/fechamentos'
    | '/gestao/pedidos'
  id:
    | '__root__'
    | '/'
    | '/gestao'
    | '/diretoria'
    | '/login'
    | '/minha-senha'
    | '/painel'
    | '/gestao/atividades'
    | '/gestao/ausencias'
    | '/gestao/avaliacao'
    | '/gestao/bonus'
    | '/gestao/configuracoes'
    | '/gestao/fabrica'
    | '/gestao/indicadores'
    | '/gestao/motivos-pausa'
    | '/gestao/motivos-perda'
    | '/gestao/origens'
    | '/gestao/produtos'
    | '/gestao/turnos'
    | '/gestao/usuarios'
    | '/posto/$postoId'
    | '/gestao/'
    | '/posto/'
    | '/gestao/fechamentos/$fechamentoId'
    | '/gestao/pedidos/$pedidoId'
    | '/gestao/fechamentos/'
    | '/gestao/pedidos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  GestaoRouteRoute: typeof GestaoRouteRouteWithChildren
  DiretoriaRoute: typeof DiretoriaRoute
  LoginRoute: typeof LoginRoute
  MinhaSenhaRoute: typeof MinhaSenhaRoute
  PainelRoute: typeof PainelRoute
  PostoPostoIdRoute: typeof PostoPostoIdRoute
  PostoIndexRoute: typeof PostoIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diretoria': {
      id: '/diretoria'
      path: '/diretoria'
      fullPath: '/diretoria'
      preLoaderRoute: typeof DiretoriaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gestao': {
      id: '/gestao'
      path: '/gestao'
      fullPath: '/gestao'
      preLoaderRoute: typeof GestaoRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/minha-senha': {
      id: '/minha-senha'
      path: '/minha-senha'
      fullPath: '/minha-senha'
      preLoaderRoute: typeof MinhaSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/painel': {
      id: '/painel'
      path: '/painel'
      fullPath: '/painel'
      preLoaderRoute: typeof PainelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gestao/': {
      id: '/gestao/'
      path: '/'
      fullPath: '/gestao/'
      preLoaderRoute: typeof GestaoIndexRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/atividades': {
      id: '/gestao/atividades'
      path: '/atividades'
      fullPath: '/gestao/atividades'
      preLoaderRoute: typeof GestaoAtividadesRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/ausencias': {
      id: '/gestao/ausencias'
      path: '/ausencias'
      fullPath: '/gestao/ausencias'
      preLoaderRoute: typeof GestaoAusenciasRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/avaliacao': {
      id: '/gestao/avaliacao'
      path: '/avaliacao'
      fullPath: '/gestao/avaliacao'
      preLoaderRoute: typeof GestaoAvaliacaoRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/bonus': {
      id: '/gestao/bonus'
      path: '/bonus'
      fullPath: '/gestao/bonus'
      preLoaderRoute: typeof GestaoBonusRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/configuracoes': {
      id: '/gestao/configuracoes'
      path: '/configuracoes'
      fullPath: '/gestao/configuracoes'
      preLoaderRoute: typeof GestaoConfiguracoesRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/fabrica': {
      id: '/gestao/fabrica'
      path: '/fabrica'
      fullPath: '/gestao/fabrica'
      preLoaderRoute: typeof GestaoFabricaRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/indicadores': {
      id: '/gestao/indicadores'
      path: '/indicadores'
      fullPath: '/gestao/indicadores'
      preLoaderRoute: typeof GestaoIndicadoresRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/motivos-pausa': {
      id: '/gestao/motivos-pausa'
      path: '/motivos-pausa'
      fullPath: '/gestao/motivos-pausa'
      preLoaderRoute: typeof GestaoMotivosPausaRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/motivos-perda': {
      id: '/gestao/motivos-perda'
      path: '/motivos-perda'
      fullPath: '/gestao/motivos-perda'
      preLoaderRoute: typeof GestaoMotivosPerdaRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/origens': {
      id: '/gestao/origens'
      path: '/origens'
      fullPath: '/gestao/origens'
      preLoaderRoute: typeof GestaoOrigensRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/produtos': {
      id: '/gestao/produtos'
      path: '/produtos'
      fullPath: '/gestao/produtos'
      preLoaderRoute: typeof GestaoProdutosRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/turnos': {
      id: '/gestao/turnos'
      path: '/turnos'
      fullPath: '/gestao/turnos'
      preLoaderRoute: typeof GestaoTurnosRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/usuarios': {
      id: '/gestao/usuarios'
      path: '/usuarios'
      fullPath: '/gestao/usuarios'
      preLoaderRoute: typeof GestaoUsuariosRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/posto/': {
      id: '/posto/'
      path: '/posto'
      fullPath: '/posto/'
      preLoaderRoute: typeof PostoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/posto/$postoId': {
      id: '/posto/$postoId'
      path: '/posto/$postoId'
      fullPath: '/posto/$postoId'
      preLoaderRoute: typeof PostoPostoIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gestao/fechamentos/': {
      id: '/gestao/fechamentos/'
      path: '/fechamentos'
      fullPath: '/gestao/fechamentos/'
      preLoaderRoute: typeof GestaoFechamentosIndexRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/fechamentos/$fechamentoId': {
      id: '/gestao/fechamentos/$fechamentoId'
      path: '/fechamentos/$fechamentoId'
      fullPath: '/gestao/fechamentos/$fechamentoId'
      preLoaderRoute: typeof GestaoFechamentosFechamentoIdRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/pedidos/': {
      id: '/gestao/pedidos/'
      path: '/pedidos'
      fullPath: '/gestao/pedidos/'
      preLoaderRoute: typeof GestaoPedidosIndexRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
    '/gestao/pedidos/$pedidoId': {
      id: '/gestao/pedidos/$pedidoId'
      path: '/pedidos/$pedidoId'
      fullPath: '/gestao/pedidos/$pedidoId'
      preLoaderRoute: typeof GestaoPedidosPedidoIdRouteImport
      parentRoute: typeof GestaoRouteRoute
    }
  }
}

interface GestaoRouteRouteChildren {
  GestaoAtividadesRoute: typeof GestaoAtividadesRoute
  GestaoAusenciasRoute: typeof GestaoAusenciasRoute
  GestaoAvaliacaoRoute: typeof GestaoAvaliacaoRoute
  GestaoBonusRoute: typeof GestaoBonusRoute
  GestaoConfiguracoesRoute: typeof GestaoConfiguracoesRoute
  GestaoFabricaRoute: typeof GestaoFabricaRoute
  GestaoIndicadoresRoute: typeof GestaoIndicadoresRoute
  GestaoMotivosPausaRoute: typeof GestaoMotivosPausaRoute
  GestaoMotivosPerdaRoute: typeof GestaoMotivosPerdaRoute
  GestaoOrigensRoute: typeof GestaoOrigensRoute
  GestaoProdutosRoute: typeof GestaoProdutosRoute
  GestaoTurnosRoute: typeof GestaoTurnosRoute
  GestaoUsuariosRoute: typeof GestaoUsuariosRoute
  GestaoIndexRoute: typeof GestaoIndexRoute
  GestaoFechamentosFechamentoIdRoute: typeof GestaoFechamentosFechamentoIdRoute
  GestaoPedidosPedidoIdRoute: typeof GestaoPedidosPedidoIdRoute
  GestaoFechamentosIndexRoute: typeof GestaoFechamentosIndexRoute
  GestaoPedidosIndexRoute: typeof GestaoPedidosIndexRoute
}

const GestaoRouteRouteChildren: GestaoRouteRouteChildren = {
  GestaoAtividadesRoute: GestaoAtividadesRoute,
  GestaoAusenciasRoute: GestaoAusenciasRoute,
  GestaoAvaliacaoRoute: GestaoAvaliacaoRoute,
  GestaoBonusRoute: GestaoBonusRoute,
  GestaoConfiguracoesRoute: GestaoConfiguracoesRoute,
  GestaoFabricaRoute: GestaoFabricaRoute,
  GestaoIndicadoresRoute: GestaoIndicadoresRoute,
  GestaoMotivosPausaRoute: GestaoMotivosPausaRoute,
  GestaoMotivosPerdaRoute: GestaoMotivosPerdaRoute,
  GestaoOrigensRoute: GestaoOrigensRoute,
  GestaoProdutosRoute: GestaoProdutosRoute,
  GestaoTurnosRoute: GestaoTurnosRoute,
  GestaoUsuariosRoute: GestaoUsuariosRoute,
  GestaoIndexRoute: GestaoIndexRoute,
  GestaoFechamentosFechamentoIdRoute: GestaoFechamentosFechamentoIdRoute,
  GestaoPedidosPedidoIdRoute: GestaoPedidosPedidoIdRoute,
  GestaoFechamentosIndexRoute: GestaoFechamentosIndexRoute,
  GestaoPedidosIndexRoute: GestaoPedidosIndexRoute,
}

const GestaoRouteRouteWithChildren = GestaoRouteRoute._addFileChildren(
  GestaoRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GestaoRouteRoute: GestaoRouteRouteWithChildren,
  DiretoriaRoute: DiretoriaRoute,
  LoginRoute: LoginRoute,
  MinhaSenhaRoute: MinhaSenhaRoute,
  PainelRoute: PainelRoute,
  PostoPostoIdRoute: PostoPostoIdRoute,
  PostoIndexRoute: PostoIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
